import axios from "axios";
import getHeaders from "../../constants/headers";
import { PRICElIST_BASE_URL } from "../BaseURL";

export const packageInfoByPriceId = (storeId, priceId) => {
    return axios({
      method: 'get',
      url:
        PRICElIST_BASE_URL +
        '/api/secure/v1/store/' +
        storeId +
        '/price/' +
        priceId +
        '/package-info',
      headers: getHeaders(),
    });
  };